var map = {
	"./kerrokset-ak-k.png": "RWXu",
	"./kerrokset-ak.png": "uBCQ",
	"./kerrokset-yk-ak-k.png": "tMu/",
	"./kerrokset-yk-ak.png": "hg0z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EEyz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kerrosluku ^\.\/kerrokset\-.*\.png$
// module id = EEyz
// module chunks = 0